import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  sentryDsn,
  amplitudeAPIKey,
  muiProKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "production",
  appRegion: "eu",
  appEnv: "eu-production",
  displayAppEnv: "Production EU",
  urls: {
    apiUrl: "https://core.api.holobuilder.eu",
    baseUrl: "https://admin.holobuilder.eu",
    dashboardUrl: "https://sphere.holobuilder.eu",
    webEditorUrl: "https://app.holobuilder.eu/app",
    entryPageUrl: "https://entry.holobuilder.eu",
    adminPanelApi: "https://admin.holobuilder.eu/api",
    cookieManagerUrl:
      "https://cookies.holobuilder.eu/cookie-manager/manager/latest",
  },
  features: {
    muiProKey,
    amplitudeAPIKey,
  },
  keys: {
    sentryDsn,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support-eu@holobuilder.com",
  isNumberedEnv: false,
  numberedEnv: null,
};
